import api from 'data/api';

export const loadMetrics = api('GET /api/mobile/dashboard/chart/metrics');
